export default __webpack_public_path__ + "static/media/ic_note_pre_process.3fb67b20.png";